import type { FaireProductEntity } from "../../entity_types/product";

export const p_jfxfy2ets6: FaireProductEntity = {
  token: "p_jfxfy2ets6",
  type: "product",
  name: "\"Climb\" Natural Colors with Gold Mountain Accent hair Tie Bracelets",
  brandToken: "b_5gtk8ay28p",
  brandName: "K'lani hair tie bracelets",
  imageUrl: "https://cdn.faire.com/fastly/b1a9368dfd1e05cdaf94c2cac5d5df82845723aa51b5bdf7639dcadd014f1095.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/424f6c181142d3cc6b4d8184d1977963610277d1de8eee572d98cc23a412d305.jpeg",
    "https://cdn.faire.com/fastly/6f5891e7a8916677f48f5948e4cfe4c06508f4b2caa99508b6945b368dd7f374.jpeg",
    "https://cdn.faire.com/fastly/06c31810ec487b20b37836587ae6da5606f2e7d0cd4819a104af8ea19a81f44f.jpeg",
    "https://cdn.faire.com/fastly/5b7a2468191fbad9a687370a00dfe2bdf2bd33453abfdb931299946a68d727c8.jpeg",
    "https://cdn.faire.com/fastly/959cd145605f121bf391bc77160433b69243ab853e718993d290bc6660ba8607.jpeg",
    "https://cdn.faire.com/fastly/cb02c9f0864208a4f991f18c382ffba270dae9d441cd2814a1ad151f06f8b3d5.jpeg",
    "https://cdn.faire.com/fastly/14a28c299cc89fbf41c47f7fa7c210234b8548b8f8e52503e22200fec383bca5.jpeg"
  ],
  priceDollars: 10,
  description: "Our Climb set includes five bracelets that double as hair ties in gorgeous warm neutrals of brown, creams, and greens. This set with mountain peaks on the gold charm will remind us that our mountain top is in reach.\n\nMedium is the size of a normal hair tie band. It fits wrists between 5-6.4\" around. \n\nSmall is better for younger girls and small teens. It fits wrists under 5\" around. \n\nLarge is sized for wrists 6.5-7.5\"\n",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T18:46:35.620Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
